import React from 'react';
import styled from 'styled-components';
import { match } from 'react-router-dom';
import { Modal } from 'antd';

import {
  SendCommunicationCustomersSelection as CustomersSelection,
  SendCommunicationFirstStepForm,
  SituationCategory,
} from 'types';
import ModalContentConfirm from 'components/organisms/modal-content-confirm';
import { useIntl } from 'common/config/i18n';

export interface Props {
  match: match<Params>;
}

export interface Params {
  situationCategory?: SituationCategory;
}

export const VerticalSpace = styled.div`
  height: 40px;
`;

export const Wrapper = styled.div`
  padding: 32px;
  padding-top: 0;
`;

export const SelectionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
`;

export const ButtonWrapper = styled.div<{ isClientType: boolean }>`
  display: flex;
  justify-content: flex-end;
  transform: translateY(${({ isClientType }) => (isClientType ? '20px' : '0')});
  transition: opacity 1s, transform 1s;
`;

export const formikInitialValues: SendCommunicationFirstStepForm = {
  customersSelection: CustomersSelection.All,
  impactedStations: [],
  excludedStations: [],
  selectedCarriages: [],
  includePassengersWithoutSeats: true,
  selectedTypologiesIds: [],
  selectedConflictTypeId: undefined,
  excludeAllConflictTypes: false,
  selectedPurchaseComparison: undefined,
  purchaseReferenceDate: undefined,
  purchaseReferenceTime: undefined,
  DVNumbers: undefined,
};

export const NoPassengersModal = ({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onConfirm: (isConfirm: boolean) => void;
}) => {
  const { t } = useIntl();

  return (
    <Modal footer={null} open={open} onCancel={onCancel}>
      <ModalContentConfirm
        row
        title={<div>{t('sendCommunication', 'modalNoPassengers', 'desc')}</div>}
        onConfirm={onConfirm}
        labelConfirm={t('Buttons', 'CONTINUE_BUTTON')}
        labelCancel={t('Buttons', 'EDIT_BUTTON')}
      />
    </Modal>
  );
};
